function getEnvironment() {
    const hostname = window.location.hostname;
    if (hostname.includes('staging.')) {
        return 'staging';
    }
    else if (/^(\d{1,3}\.){3}\d{1,3}$/.test(hostname) || hostname === 'localhost' || hostname.includes('.local')) {
        return 'local';
    }
    else {
        return 'production';
    }
}
export default getEnvironment;
